<template>
  <section>
    <b-loading :is-full-page="true" :active="loading"></b-loading>
    <br />
    <div class="box is-light wdt">
      <div class="tile is-parent is-vertical centered field">
        <div class="image">
          <img src="/images/TC wired for Gant Travel.png" />
        </div>
        <br />

        <!-- Step 1: email + join code -->
        <template v-if="!emailValid">
          <b-field placeholder="Email" label="Enter your work email to get started">
            <b-input
              v-model="email"
              @keyup.native.enter="checkEmail"
              data-test="email_input"
              placeholder="Email"
              name="email"
              type="email"
            ></b-input>
          </b-field>

          <b-field placeholder="Join code" label="Have a join code? Enter it below">
            <b-input
              v-model="joinCode"
              type="text"
              name="join-code"
              placeholder="Join code"
            />
          </b-field>

          <b-message
            v-if="registrationMessage"
            type="is-danger"
            aria-close-label="Close message"
            data-test="error_message"
          >
            {{ registrationMessage }}
          </b-message>

          <b-button
            size="is-medium"
            type="is-gant"
            class="ubuntu"
            data-test="login_button"
            @click="checkEmail"
            expanded
            :disabled="!isEmailFilled"
          >
            <h5>Submit</h5>
          </b-button>
        </template>

        <!-- Step 2: profile form -->
        <template v-if="emailValid">
          <b-message v-if="accountName" type="is-info">
            Please complete your profile to join <b>{{ accountName }}</b>.
            If this is not the organization you wish to join, please
            <a href="/register">restart your registration.</a>
          </b-message>

          <b-message type="is-warning" class="mb-4">
            Enter your name exactly as it appears on your government-issued ID.
          </b-message>

          <b-notification
            type="is-danger is-light"
            class="my-3"
            v-if="validationErrors.length > 0"
          >
            <h4 class="is-size-5">Please correct the following errors:</h4>
            <div class="content">
              <ul>
                <li v-for="(validationError, index) in validationErrors" :key="index">
                  {{ validationError }}
                </li>
              </ul>
            </div>
          </b-notification>

          <div class="columns is-mobile">
            <div class="column sect">

              <!-- Name row: first / middle / last -->
              <div class="columns">
                <div class="column is-4">
                  <b-field label="First Name">
                    <b-input
                      v-model="user.firstName"
                      required
                      validation-message="Please enter a valid name"
                      pattern="[a-zA-Z]*"
                    ></b-input>
                  </b-field>
                </div>
                <div class="column is-4">
                  <b-field label="Middle Name">
                    <b-input v-model="user.middleName" pattern="[a-zA-Z]*"></b-input>
                  </b-field>
                </div>
                <div class="column is-4">
                  <b-field label="Last Name">
                    <b-input
                      v-model="user.lastName"
                      required
                      validation-message="Please enter a valid name"
                      pattern="[a-zA-Z]*"
                    ></b-input>
                  </b-field>
                </div>
              </div>

              <!-- Suffix + DOB + Gender row -->
              <div class="columns">
                <div class="column is-4">
                  <b-field label="Suffix (optional)">
                    <b-select v-model="user.suffix" placeholder="None" expanded>
                      <option value="">None</option>
                      <option value="Jr.">Jr.</option>
                      <option value="Sr.">Sr.</option>
                      <option value="II">II</option>
                      <option value="III">III</option>
                      <option value="IV">IV</option>
                      <option value="V">V</option>
                      <option value="Esq.">Esq.</option>
                    </b-select>
                  </b-field>
                </div>
                <div class="column is-4">
                  <b-field label="Date of Birth">
                    <b-input
                      v-model="user.dob"
                      v-cleave="masks.dob"
                      required
                      placeholder="mm/dd/yyyy"
                    />
                  </b-field>
                </div>
                <div class="column is-4">
                  <b-field label="Gender (optional)">
                    <b-select v-model="user.gender" placeholder="Select" expanded>
                      <option value="Male">Male</option>
                      <option value="Female">Female</option>
                      <option value="X">Non-Binary</option>
                    </b-select>
                  </b-field>
                </div>
              </div>

              <!-- Phone + Email row -->
              <div class="columns">
                <div class="column is-6">
                  <b-field label="Mobile Phone">
                    <b-input
                      required
                      v-model="user.mobilePhone"
                      v-cleave="masks.phone"
                    ></b-input>
                  </b-field>
                </div>
                <div class="column is-6">
                  <b-field label="Email">
                    <b-input v-model="email" readonly disabled type="email" />
                  </b-field>
                </div>
              </div>

            </div>
          </div>

          <b-button
            size="is-medium"
            type="is-gant"
            class="ubuntu"
            data-test="register_button"
            @click="registerUser"
            expanded
          >
            <h5>Register</h5>
          </b-button>
        </template>

        <div class="my-4">
          <p class="text-center register ubuntu">
            Already have an account?
            <a href="/login" id="signup" class="teal-text">Login</a>
          </p>
        </div>
        <br />
      </div>
    </div>
    <br />
  </section>
</template>

<script>
import Cleave from 'cleave.js';

const cleave = {
  name: 'cleave',
  bind(el, binding) {
    const input = el.querySelector('input');
    input._vCleave = new Cleave(input, binding.value);
  },
  unbind(el) {
    const input = el.querySelector('input');
    input._vCleave.destroy();
  },
};

export default {
  directives: { cleave },
  name: 'Register',

  data() {
    return {
      email:          '',
      emailValid:     false,
      loading:        false,
      registrationId: null,
      accountName:    '',
      masks: {
        phone: { phone: true, phoneRegionCode: 'US', delimiter: '-' },
        dob:   { date: true, delimiter: '/', datePattern: ['m', 'd', 'Y'] },
      },
      user: {
        firstName:   '',
        middleName:  '',
        lastName:    '',
        suffix:      '',
        gender:      '',
        mobilePhone: '',
        dob:         '',
      },
      validationErrors:    [],
      registrationMessage: '',
      joinCode:            '',
    };
  },

  computed: {
    isEmailFilled() {
      return this.email !== '';
    },
  },

  created() {
    const joinCode = this.$route.params.joinCode;
    if (joinCode) {
      this.joinCode = joinCode;
    }
  },

  methods: {
    validateForm() {
      const errors = [];
      if (!this.user.firstName)   errors.push('First name is required');
      if (!this.user.lastName)    errors.push('Last name is required');
      if (!this.user.dob)         errors.push('Date of birth is required');
      if (!this.user.mobilePhone) errors.push('Mobile phone is required');
      this.validationErrors = errors;
      return errors.length === 0;
    },

    async checkEmail() {
      this.loading = true;

      let userIpAddress = '';
      try {
        const ipResponse = await fetch('https://api.ipify.org?format=json');
        const ipData     = await ipResponse.json();
        userIpAddress    = ipData.ip;
      } catch (_) { /* non-critical */ }

      const body = { email: this.email, ip_address: userIpAddress };
      const url  = this.joinCode
        ? 'profile/register/check-join-code'
        : 'profile/register/check-email';

      if (this.joinCode) body.join_code = this.joinCode;

      this.$app
        .huddleLabsServerCall(url, body)
        .then((result) => {
          this.loading = false;
          if (result.valid) {
            this.emailValid          = true;
            this.registrationId      = result.registrationId;
            this.accountName         = result.account;
            this.registrationMessage = '';
          } else {
            this.registrationMessage = 'You cannot register with this email.';
            this.accountName         = '';
          }
        })
        .catch((error) => {
          this.loading = false;
          this.failure(error);
        });
    },

    async registerUser() {
      if (!this.validateForm()) return;

      this.loading    = true;
      this.user.email = this.email;

      const body = { user: this.user, registrationId: this.registrationId };

      this.$app
        .huddleLabsServerCall('profile/register/create-profile', body)
        .then((result) => {
          this.loading = false;
          if (result.success) {
            sessionStorage.setItem('reg_registrationId', result.registrationId || this.registrationId);
            sessionStorage.setItem('reg_email', this.email);
            this.$router.push('/register/email/check');
          } else {
            this.failure(result.message || 'Registration failed.');
          }
        })
        .catch((error) => {
          this.loading = false;
          this.failure(error);
        });
    },

    failure(msg = '') {
      this.$buefy.toast.open({
        duration: 5000,
        message:  `An error occurred: ${msg}`,
        position: 'is-bottom',
        type:     'is-danger',
      });
    },
  },
};
</script>

<style scoped>
.image {
  margin: 0 auto;
  padding: 15px;
  width: 50%;
  text-align: center;
  display: block;
}

.text-center { text-align: center; }
.centered    { margin: auto; }
.field       { border-radius: 5px; }

.wdt {
  width: 700px !important;
  margin: auto;
}

.register {
  background-color: #ddd;
  border-radius: 5px;
  padding-top: 5px;
  padding-bottom: 5px;
}

@media screen and (max-width: 1023px) {
  .wdt { width: 100%; margin: auto; }
}

@media screen and (min-width: 1024px) {
  .wdt { width: 700px; margin: auto; }
}
</style>
